import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dateFormatType from 'src/utils/dateFormatType';
import selectFormatDate from 'src/utils/selectDateFormat';
import { formatPositiveAmount } from 'src/utils/formatAmout';
import {
  HEADING_TEXT_COLOR,
  HAIRLINE_BORDER_COLOR,
  LINK_COLOR,
  ASSOCIATED_META_COLOR,
  PAYMENT_DATE_COLOR
} from './styleConstants';

const RelatedInvoiceRow = ({
  invoiceId,
  folio,
  date,
  contractFolioWithoutPrefix,
  paymentMethod,
  appliedAmount
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '118px minmax(220px, 1fr) minmax(170px, 0.42fr)',
        gap: '10px 18px',
        alignItems: 'center',
        minHeight: '88px',
        padding: '16px 22px',
        borderBottom: `1px solid ${HAIRLINE_BORDER_COLOR}`,
        '&:last-child': { borderBottom: 0 }
      }}
    >
      <Typography sx={{ color: PAYMENT_DATE_COLOR, fontSize: '13px' }}>
        {selectFormatDate(date, dateFormatType.DAY)}
      </Typography>
      <Box sx={{ minWidth: 0, display: 'grid', gap: '5px' }}>
        <Typography
          component={Link}
          to={`/invoice/${invoiceId}`}
          sx={{ color: LINK_COLOR, fontSize: '18px', fontWeight: 800, textDecoration: 'none' }}
        >
          {folio}
        </Typography>
        <Typography sx={{ color: ASSOCIATED_META_COLOR, fontSize: '12px' }}>
          {[contractFolioWithoutPrefix || t('TRANSACTION.NO_CONTRACT_ASSOCIATED'), paymentMethod]
            .filter(Boolean)
            .join(' · ')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gap: '4px',
          minWidth: 0,
          paddingLeft: '18px',
          borderLeft: `1px solid ${HAIRLINE_BORDER_COLOR}`,
          textAlign: 'right'
        }}
      >
        <Typography
          component="span"
          sx={{
            color: PAYMENT_DATE_COLOR,
            fontSize: '11px',
            fontWeight: 800,
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
          }}
        >
          {t('TRANSACTION.DETAIL.APPLIED_AMOUNT')}
        </Typography>
        <Typography
          sx={{
            color: HEADING_TEXT_COLOR,
            fontWeight: 800,
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap'
          }}
        >
          {formatPositiveAmount(appliedAmount)}
        </Typography>
      </Box>
    </Box>
  );
};

RelatedInvoiceRow.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  folio: PropTypes.string,
  date: PropTypes.string.isRequired,
  contractFolioWithoutPrefix: PropTypes.string,
  paymentMethod: PropTypes.string,
  appliedAmount: PropTypes.number.isRequired
};

RelatedInvoiceRow.defaultProps = {
  folio: null,
  contractFolioWithoutPrefix: null,
  paymentMethod: null
};

export default RelatedInvoiceRow;
